module.exports = __webpack_public_path__ + "img/cat-02-ac.f006a52b.svg";